import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from "primereact/progressspinner";
import { formatDateWithTime } from "../../../../shared/utility";
import TraceableBarcode from "../../../controls/TraceableBarcode";
import TraceableLotNumber, {
  getInventoryLotTraceType,
} from "../../../controls/TraceableLotNumber";

export default function WipIncomingSubTable2(props) {
  const { data, loadingRows, rowDetails } = props;

  if (loadingRows[data.unique_id]) {
    return <ProgressSpinner style={{ width: "30px", height: "30px" }} />;
  }

  const detail = rowDetails[data.unique_id];
  if (!detail) return null;

  const bodyItemProductName = (item) => {
    return (
      <div>
        {item.product_name} <br />{" "}
        <span className="font-bold">PLU: {item.plu}</span>
      </div>
    );
  };

  const bodyItemWeight = (item) => {
    return <p>{item.weight_in_kg} kg</p>;
  };

  const bodyItemPieces = (item) => {
    return <p>{item.piece_count} pieces</p>;
  };

  const bodyFormatCreatedDate = (item) => {
    return <p>{formatDateWithTime(item.created_date)}</p>;
  };

  const lotNumberBody = (rowData) => (
    <TraceableLotNumber
      lotNumber={rowData.lot_number}
      traceType={getInventoryLotTraceType(rowData)}
    />
  );

  const barcodeBody = (rowData) => (
    <TraceableBarcode barcode={rowData.barcode} />
  );

  return (
    <div>
      <DataTable
        value={rowDetails[data.unique_id]}
        tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm receiving-sub-items-table-2"
        cellClassName="py-2 border-1-bottom-gray px-2 text-sm"
      >
        <Column
          header="Product Name"
          body={bodyItemProductName}
          style={{ width: "23%" }}
        />
        <Column
          header="Lot Number"
          body={lotNumberBody}
          style={{ width: "10%" }}
        />
        <Column body={barcodeBody} header="Barcode" style={{ width: "20%" }} />
        <Column
          field="added_by_name"
          header="Added by"
          style={{ width: "8%" }}
        />
        <Column
          header="Date added"
          body={bodyFormatCreatedDate}
          style={{ width: "12%" }}
        />
        <Column
          header="Total Weight"
          body={bodyItemWeight}
          style={{ width: "7%", textAlign: "right" }}
        />
        <Column
          header="Total Pieces"
          body={bodyItemPieces}
          style={{ width: "7%", textAlign: "right" }}
        />
      </DataTable>
    </div>
  );
}
